// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTabs_root__3U2eY","tab":"ProcedureTabs_tab__2PwE6"};